export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    start: function start() {},
    stop: function stop() {}
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};